export default __webpack_public_path__ + "static/media/icon4.7ff3f23b.png";